module.exports = __webpack_public_path__ + "img/Calendar_Icon.0bc00c7f.svg";